"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NewMatchingDialogModule = /** @class */ (function () {
    function NewMatchingDialogModule() {
    }
    return NewMatchingDialogModule;
}());
exports.NewMatchingDialogModule = NewMatchingDialogModule;
